import React from 'react';
import { Box, Grid, Stack, Typography } from '@mui/material';

export const COLORS = {
  primary: '#4318FF',
  primaryDark: '#3212D6',
  primarySoft: '#F0EDFF',
  primarySofter: '#FAFAFF',
  text: '#2B3674',
  muted: '#8A94A6',
  mutedBorder: '#E9EDF5',
  bg: '#F8FAFC',
  success: '#16834B',
  successBg: '#EAFBF1',
  warning: '#A15C00',
  warningBg: '#FFF7E8',
};

export const formatDate = (value) => {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' });
};

export const formatDateTime = (value) => {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
};

export const formatFileSize = (bytes) => {
  if (!bytes || Number(bytes) === 0) return '0 octet';
  const size = Number(bytes);
  if (size < 1024) return `${size} octets`;
  if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)} Ko`;
  return `${(size / (1024 * 1024)).toFixed(1)} Mo`;
};

export const displayValue = (value) => {
  if (value === null || value === undefined || value === '') {
    return 'Non renseigné';
  }
  return value;
};

export const isFilled = (value) => value !== null && value !== undefined && value !== '';

export const InfoField = ({ label, value, icon, fullWidth = false, multiline = false }) => {
  return (
    <Grid item xs={12} md={fullWidth ? 12 : 6}>
      <Box sx={{ height: '100%', p: 2, borderRadius: '12px', backgroundColor: '#F8FAFC', border: '1px solid #E9EDF5', transition: 'all .2s ease', '&:hover': { borderColor: '#D8D0FF', backgroundColor: COLORS.primarySofter } }}>
        <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 0.8 }}>
          {icon && <Box sx={{ display: 'flex', alignItems: 'center', color: COLORS.primary }}>{icon}</Box>}
          <Typography variant="caption" sx={{ color: COLORS.muted, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.4 }}>{label}</Typography>
        </Stack>
        <Typography variant="body1" sx={{ color: COLORS.text, fontWeight: 600, lineHeight: 1.6, whiteSpace: multiline ? 'pre-wrap' : 'normal', wordBreak: 'break-word' }}>
          {displayValue(value)}
        </Typography>
      </Box>
    </Grid>
  );
};

export const Section = ({ icon, title, subtitle, children }) => {
  return (
    <Box sx={{ mb: 3, p: { xs: 2, md: 2.5 }, borderRadius: '16px', border: `1px solid ${COLORS.mutedBorder}`, backgroundColor: '#FFFFFF' }}>
      <Stack direction="row" spacing={1.5} alignItems="center" sx={{ mb: 2.5 }}>
        <Box sx={{ width: 40, height: 40, borderRadius: '10px', backgroundColor: COLORS.primarySoft, display: 'flex', alignItems: 'center', justifyContent: 'center', color: COLORS.primary, flexShrink: 0 }}>
          {icon}
        </Box>
        <Box>
          <Typography sx={{ color: COLORS.text, fontWeight: 800, fontSize: '16px' }}>{title}</Typography>
          {subtitle && <Typography variant="caption" sx={{ color: COLORS.muted }}>{subtitle}</Typography>}
        </Box>
      </Stack>
      {children}
    </Box>
  );
};